import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import Button from 'shared/components/vxl/Button/Button';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import Illustration, {
  IllustrationKeyType,
} from 'shared/components/vxl/Illustration/Illustration';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';
import BodyXSText from 'shared/components/vxl/typography/primary/body/BodyXSText';
import theme from 'shared/styles/theme';

export interface AccountActionCardActivationProps {
  id: string;
  titleText: string;
  illustrationKey: IllustrationKeyType;
  cardActivationAction: () => void;
  infoText?: string;
}
const AccountActionCardActivation = ({
  titleText,
  illustrationKey,
  cardActivationAction,
  infoText,
}: AccountActionCardActivationProps) => {
  const { t: translatedText } = useTranslation('horizontalAccountCard', {
    keyPrefix: 'accountCard',
  });

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <View style={styles.iconContainer}>
          <Illustration illustration={illustrationKey} />
        </View>
        <View style={styles.textContainer}>
          <BodySmText numberOfLines={0}>{titleText}</BodySmText>
          <View style={styles.buttonWrapper}>
            <Button
              label={translatedText('buttons.activateLabel')}
              size="SMALL"
              width="HUG"
              onPress={cardActivationAction}
            />
          </View>
        </View>
      </View>
      {infoText ? (
        <View style={styles.infoTextContainer}>
          <HairLineDivider />
          <View style={styles.footer}>
            <Icon
              iconKey="INFO"
              iconSize="SM"
              iconColor={theme.color.interactive.primary}
            />
            <BodyXSText style={styles.infoText} numberOfLines={0}>
              {infoText}
            </BodyXSText>
          </View>
        </View>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  buttonWrapper: { alignSelf: 'flex-start' },
  container: {
    flexDirection: 'column',
    gap: theme.spacing.s,
    paddingHorizontal: theme.spacing.m,
    paddingTop: 12,
  },
  footer: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing.xs,
    justifyContent: 'center',
    paddingVertical: theme.spacing.s,
  },
  header: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing.m,
  },
  iconContainer: {
    alignItems: 'center',
    height: 64,
    justifyContent: 'center',
    paddingHorizontal: theme.spacing.xs,
    width: 40,
  },
  infoText: {
    color: theme.color.interactive.primary,
  },
  infoTextContainer: {
    paddingTop: theme.spacing.s,
  },
  textContainer: {
    flex: 1,
    gap: theme.spacing.s,
  },
});

export default AccountActionCardActivation;
